module.exports = "https://static.wmbcdn.com/uniweb/images/54fd6c78d1873b73970033abb8ff0545.svg";